
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/before-location-privacy-20260805",
      function () {
        return require("private-next-pages/policy/before-location-privacy-20260805.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/before-location-privacy-20260805"])
      });
    }
  